import { forwardRef, type Ref, type SVGProps } from "react";
const IconFileTextOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M9.39 22.16h1.4v-4.12h1.31v-1.21H8.08v1.21h1.31z" />
    <path d="M14.97 22.16 16 20.48l1.03 1.68h1.68l-1.78-2.62 1.69-2.71h-1.69L16 18.51l-.94-1.68h-1.58l1.68 2.62-1.78 2.71z" />
    <path d="M21.21 22.16h1.4v-4.12h1.31v-1.21H19.9v1.21h1.31z" />
    <path d="M28 13h-1V9.43a1 1 0 0 0-.29-.71L20.3 2.29a1 1 0 0 0-.71-.29H6a1 1 0 0 0-1 1v10H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h1v3a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-3h1a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2m-3.84-4H20V4.83ZM7 4h11v6a1 1 0 0 0 1 1h6v2H7Zm18 24H7v-2h18Zm3-4H4v-9h24Z" />
  </svg>
);
const ForwardRef = forwardRef(IconFileTextOutlineSVG);
ForwardRef.displayName = "IconFileTextOutline";
export { ForwardRef as IconFileTextOutline };
